import { render, staticRenderFns } from "./VersionLottery.vue?vue&type=template&id=5c148d4b&scoped=true"
import script from "./VersionLottery.vue?vue&type=script&lang=js"
export * from "./VersionLottery.vue?vue&type=script&lang=js"
import style0 from "./VersionLottery.vue?vue&type=style&index=0&id=5c148d4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c148d4b",
  null
  
)

export default component.exports